/**
 * @file Allow using app feature flags
 */
import window from 'bits/global'

window.ww = window.ww || {}

const flip = window.ww.flip || {}

type CurrentFlags = 'wishOrderArray' | 'debugFrontend' | 'newSettings' | 'goldPlansVisible'

function isAppUsing(feature: CurrentFlags): boolean {
  return flip[feature] || false
}

export { isAppUsing }
